import { useParams } from 'react-router-dom';

import {
  Datagrid,
  List,
  TextField,
  DateField,
  TextInput,
  SelectInput,
  DateInput,
  Show,
  SimpleShowLayout,
  NumberField,
  SimpleForm,
  Toolbar,
  SaveButton,
  Labeled,
  Edit,
  FileInput,
  ImageField,
  useRedirect,
  useNotify,
  useRecordContext,
  required,
  FileField,
  useUpdate,
  useGetOne,
  downloadCSV,
  Tab,
  TabbedShowLayout
} from "react-admin";
import { Card, CardContent, Grid, Typography, Divider, Box, Chip, IconButton, Alert } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import StoreIcon from "@mui/icons-material/Store";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import PeopleIcon from "@mui/icons-material/People";
import { useEffect, useRef, useState } from "react";
import UserDialog from "./components/user-details";
import OrderDialog from "./components/order-dialog";
import { unparse as convertToCSV } from 'papaparse';
import jsonExport from 'jsonexport/dist';
import ImageGallery from './components/orders/ImageGallery';
import OrderStatusTimeline from './components/orders/OrderStatusTimeline';


const orderFilters = [
  <TextInput label="Search Name/Phone" source="search" alwaysOn />,
  <SelectInput
    label="Negotiation Type"
    source="negotiationType"
    choices={[
      { id: "", name: "All" },
      { id: "Crop", name: "Crop" },
      { id: "Input", name: "Input" },
      { id: "Service", name: "Service" },
    ]}
    alwaysOn
    optionText="name"
    optionValue="id"
  />,
  <SelectInput
    label="Trade Type"
    source="tradeType"
    choices={[
      { id: "", name: "All" },
      { id: "Offer", name: "Offer" },
      { id: "Demand", name: "Demand" },
    ]}
    alwaysOn
    optionText="name"
    optionValue="id"
  />,
];
const customExporter = (records) => {
  const csvData = records.map(record => ({
    // Order fields
    ID: record.id,
    Price: record.price,
    Quantity: record.quantity,
    DeliveryDate: record.deliveryDate,
    Status: record.status,
    // Images: Array.isArray(record.images) ? record.images.join(", ") : record.images,
    Feedback: record.feedback,
    CreatedAt: record.createdAt ? new Date(record.createdAt).toLocaleDateString() : "",
    UpdatedAt: record.updatedAt ? new Date(record.updatedAt).toLocaleDateString() : "",

    // Buyer fields
    Buyer_Name: record.buyer?.name,
    Buyer_PhoneNumber: record.buyer?.phonenumber ? `'${record.buyer.phonenumber}` : "",
    Buyer_Location: record.buyer?._state?.name,
    Buyer_City: record.buyer?._city?.name,
    Buyer_CreatedAt: record.buyer?.created_at ? new Date(record.buyer.created_at).toLocaleDateString() : "",
    Buyer_UpdatedAt: record.buyer?.updated_at ? new Date(record.buyer.updated_at).toLocaleDateString() : "",
    Buyer_Type: record.buyer?.type,
    Buyer_Gender: record.buyer?.gender,
    Buyer_SubscribedAt: record.buyer?.subscribed_at ? new Date(record.buyer.subscribed_at).toLocaleDateString() : "",
    Buyer_DOB: record.buyer?.dob ? new Date(record.buyer.dob).toLocaleDateString() : "",
    Buyer_CooperativeType: record.buyer?.cooperativeType,
    Buyer_NoOfMembers: record.buyer?.NoOfMembers,
    Buyer_IsSubscribed: record.buyer?.isSubscribed,
    Buyer_IsVerified: record.buyer?.isVerified,
    Buyer_Files: Array.isArray(record.buyer?.files) ? record.buyer.files.join(", ") : record.buyer?.files,

    // Seller fields
    Seller_Name: record.negotiation?.seller?.name,
    Seller_PhoneNumber: record.negotiation?.seller?.phonenumber ? `'${record.negotiation.seller.phonenumber}` : "",
    Seller_Location: record.negotiation?.seller?._state?.name,
    Seller_City: record.negotiation?.seller?._city?.name,
    Seller_CreatedAt: record.negotiation?.seller?.created_at ? new Date(record.negotiation.seller.created_at).toLocaleDateString() : "",
    Seller_UpdatedAt: record.negotiation?.seller?.updated_at ? new Date(record.negotiation.seller.updated_at).toLocaleDateString() : "",
    Seller_Type: record.negotiation?.seller?.type,
    Seller_Gender: record.negotiation?.seller?.gender,
    Seller_SubscribedAt: record.negotiation?.seller?.subscribed_at ? new Date(record.negotiation.seller.subscribed_at).toLocaleDateString() : "",
    Seller_DOB: record.negotiation?.seller?.dob ? new Date(record.negotiation.seller.dob).toLocaleDateString() : "",
    Seller_CooperativeType: record.negotiation?.seller?.cooperativeType,
    Seller_NoOfMembers: record.negotiation?.seller?.NoOfMembers,
    Seller_IsSubscribed: record.negotiation?.seller?.isSubscribed,
    Seller_IsVerified: record.negotiation?.seller?.isVerified,
    Seller_Files: Array.isArray(record.negotiation?.seller?.files) ? record.negotiation.seller.files.join(", ") : record.negotiation?.seller?.files,

    // Negotiation fields
    Negotiation_ID: record.negotiation?.id,
    Negotiation_Type: record.negotiation?.type,
    Negotiation_TradeType: record.negotiation?.tradeType,
    Negotiation_Quantity: record.negotiation?.quantity,
    Negotiation_ItemId: record.negotiation?.itemId,
    Negotiation_Status: record.negotiation?.status,
    Negotiation_CreatedAt: record.negotiation?.createdAt ? new Date(record.negotiation.createdAt).toLocaleDateString() : "",
    Negotiation_UpdatedAt: record.negotiation?.updatedAt ? new Date(record.negotiation.updatedAt).toLocaleDateString() : "",
  }));


  const csv = convertToCSV(csvData);
  jsonExport(csvData, { rowDelimiter: ',' }, (err, csv) => {
    if (err) {
      console.error(err);
      return;
    }
    // Add UTF-8 BOM to fix Arabic characters in Excel
    const bom = '\uFEFF';
    downloadCSV(bom + csv, 'orders_export');
  });
};
export const OrderList = (props) => (
  <List {...props} filters={orderFilters} exporter={customExporter}>
    <Datagrid rowClick={"show"}>
      <TextField source="id" />
      <TextField source="buyer.name" label="Buyer" />
      <TextField source="buyer.phonenumber" label="Buyer Phone" />
      <TextField source="negotiation.type" label="Negotiation Type" />
      <TextField source="negotiation.tradeType" label="Trade Type" />
      <TextField source="status" label="Status" />
      <TextField source="feedback" label="Feedback" />
      <DateField source="createdAt" label="Date" />
    </Datagrid>
  </List>
);

const API_URL = process.env.REACT_APP_URL || 'http://localhost:3060';

const statusColors = {
  pending: "warning",
  completed: "success",
  canceled: "error",
};

const ImageSlider = ({ images, title }) => {
  const API_URL = process.env.REACT_APP_URL || 'http://localhost:3060';
  const [currentIndex, setCurrentIndex] = useState(0);

  // Function to build the complete image URL
  const getImageUrl = (imgPath) => {
    if (!imgPath) return '';

    // If it's already a full URL (http/https), use as-is
    if (/^https?:\/\//i.test(imgPath)) {
      return imgPath;
    }

    // If it starts with a slash, prepend API_URL
    if (imgPath.startsWith('/')) {
      return `${API_URL}${imgPath}`;
    }

    // For relative paths without leading slash
    return `${API_URL}/${imgPath}`;
  };

  const handlePrev = () => {
    setCurrentIndex(prev => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex(prev => (prev === images.length - 1 ? 0 : prev + 1));
  };

  if (!images || images.length === 0) return null;

  return (
    <Box sx={{ mt: 3, mb: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
        {title}
      </Typography>
      <Box sx={{ position: 'relative', height: 300 }}>
        <img
          src={getImageUrl(images[currentIndex])}
          alt={`${title} ${currentIndex + 1}`}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            borderRadius: 4,
            border: '1px solid #ddd'
          }}
          onError={(e) => {
            e.target.onerror = null; // Prevent infinite loop
            e.target.src = `${API_URL}/default-image.jpg`; // Fallback image
          }}
        />

        {images.length > 1 && (
          <>
            <IconButton
              onClick={handlePrev}
              sx={{
                position: 'absolute',
                left: 8,
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: 'rgba(255,255,255,0.7)',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }
              }}
            >
              ◀
            </IconButton>
            <IconButton
              onClick={handleNext}
              sx={{
                position: 'absolute',
                right: 8,
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: 'rgba(255,255,255,0.7)',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }
              }}
            >
              ▶
            </IconButton>
          </>
        )}
      </Box>
      <Typography variant="caption" sx={{ textAlign: 'center', display: 'block', mt: 1 }}>
        Image {currentIndex + 1} of {images.length}
      </Typography>
    </Box>
  );
};


export const OrderShow = (props) => {
  const { id } = useParams();
  const { data: record, isLoading, error } = useGetOne('orders', { id });

  if (isLoading) return <div>Loading order details...</div>;
  if (error) return <div>Error loading order: {error.message}</div>;
  if (!record) return <div>Order not found</div>;

  return (
    <Show {...props}>
      <TabbedShowLayout>
        {/* Tab 1: Order Information */}
        <Tab label="Order Details" icon={<ShoppingCartIcon />}>
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                Order Information
              </Typography>
              <Divider sx={{ mb: 2 }} />

              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={4}>
                  <Labeled label="Order ID">
                    <Typography variant="body1">
                      #{record.id}
                    </Typography>
                  </Labeled>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Labeled label="Order Type">
                    <Chip
                      label={record.isInKind ? "In-Kind Contribution" : "Regular Order"}
                      color={record.isInKind ? "primary" : "default"}
                      variant="outlined"
                    />
                  </Labeled>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Labeled label="Status">
                    <Chip
                      label={record.status || 'Pending'}
                      color={
                        record.status === 'Delivered' || record.status === 'Received' ? 'success' :
                          record.status === 'Cancelled' ? 'error' :
                            record.status === 'Processing' ? 'warning' : 'default'
                      }
                      variant="outlined"
                      sx={{ fontWeight: 'bold' }}
                    />
                  </Labeled>
                </Grid>

                {record.isInKind && record.inKindStatus && (
                  <Grid item xs={12} sm={6} md={4}>
                    <Labeled label="In-Kind Status">
                      <Chip
                        label={record.inKindStatus}
                        color={
                          record.inKindStatus === 'Received' || record.inKindStatus === 'Delivered' ? 'success' :
                            record.inKindStatus === 'Cancelled' ? 'error' :
                              record.inKindStatus === 'InTransit' ? 'warning' : 'info'
                        }
                        variant="outlined"
                        sx={{ fontWeight: 'bold' }}
                      />
                    </Labeled>
                  </Grid>
                )}

                <Grid item xs={12} sm={6} md={4}>
                  <Labeled label="Price">
                    <Typography variant="body1">
                      {record.price > 0 ? `${record.price} SDG` : 'Free'}
                    </Typography>
                  </Labeled>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Labeled label="Quantity">
                    <Typography variant="body1">
                      {record.quantity}
                    </Typography>
                  </Labeled>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Labeled label="Delivery Date">
                    <DateField source="deliveryDate" showTime />
                  </Labeled>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Labeled label="Created At">
                    <DateField source="createdAt" showTime />
                  </Labeled>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Labeled label="Updated At">
                    <DateField source="updatedAt" showTime />
                  </Labeled>
                </Grid>

                {record.feedback && (
                  <Grid item xs={12}>
                    <Labeled label="Feedback">
                      <Typography variant="body1">
                        {record.feedback}
                      </Typography>
                    </Labeled>
                  </Grid>
                )}
              </Grid>
            </CardContent>
          </Card>



          {/* Buyer & Seller Information */}
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                Parties Involved
              </Typography>
              <Divider sx={{ mb: 2 }} />

              <Grid container spacing={3}>
                {/* Buyer Info */}
                <Grid item xs={12} md={6}>
                  <Card variant="outlined">
                    <CardContent>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: 'primary.main' }}>
                        <PersonIcon sx={{ mr: 1, verticalAlign: 'middle' }} />

                        {record.isInKind ? 'CC Information' : 'Buyer Information'}
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Labeled label="Name">
                            <UserDialog source="buyer" path="negotiation.buyer" />
                          </Labeled>
                        </Grid>
                        <Grid item xs={12}>
                          <Labeled label="Phone">
                            <Typography variant="body1">
                              {record.buyer?.phonenumber}
                            </Typography>
                          </Labeled>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Seller Info */}
                <Grid item xs={12} md={6}>
                  <Card variant="outlined">
                    <CardContent>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: 'success.main' }}>
                        <StoreIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                        {record.isInKind ? 'SME Information' : 'Seller Information'}

                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Labeled label="Name">
                            <UserDialog source="seller" path="negotiation.seller" />
                          </Labeled>
                        </Grid>
                        <Grid item xs={12}>
                          <Labeled label="Phone">
                            <Typography variant="body1">
                              {record.negotiation?.seller?.phonenumber}
                            </Typography>
                          </Labeled>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* In-Kind Order Timeline */}
          {record.isInKind && (
            <OrderStatusTimeline order={record} />
          )}
        </Tab>

        {/* Tab 2: Order Images */}
        <Tab label="Images" icon={<PhotoLibraryIcon />}>
          {record.isInKind ? (
            // In-Kind Order Images by Status
            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
                In-Kind Order Images by Status
              </Typography>

              {/* Dispatched Images */}
              {record.dispatchedImages?.length > 0 && (
                <ImageGallery
                  images={record.dispatchedImages}
                  title="Dispatched Images"
                  category="dispatched"
                  maxColumns={3}
                />
              )}

              {/* In-Transit Images */}
              {record.inTransitImages?.length > 0 && (
                <ImageGallery
                  images={record.inTransitImages}
                  title="In-Transit Images"
                  category="intransit"
                  maxColumns={3}
                />
              )}

              {/* Delivered Images */}
              {record.deliveredImages?.length > 0 && (
                <ImageGallery
                  images={record.deliveredImages}
                  title="Delivered Images"
                  category="delivered"
                  maxColumns={3}
                />
              )}

              {/* Received Images */}
              {record.receivedImages?.length > 0 && (
                <ImageGallery
                  images={record.receivedImages}
                  title="Received Images"
                  category="received"
                  maxColumns={3}
                />
              )}

              {/* Show message if no images */}
              {!record.dispatchedImages?.length &&
                !record.inTransitImages?.length &&
                !record.deliveredImages?.length &&
                !record.receivedImages?.length && (
                  <Alert severity="info" sx={{ mt: 2 }}>
                    No images have been uploaded for this in-kind order yet.
                  </Alert>
                )}
            </Box>
          ) : (
            // Regular Order Images
            <Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
                Regular Order Images
              </Typography>

              {/* Payment Images */}
              {record.paymentImages?.length > 0 && (
                <ImageGallery
                  images={record.paymentImages}
                  title="Payment Proofs"
                  category="payment"
                  maxColumns={3}
                />
              )}

              {/* Delivery Images */}
              {record.images?.length > 0 && (
                <ImageGallery
                  images={record.images}
                  title="Delivery Proofs"
                  category="delivery"
                  maxColumns={3}
                />
              )}

              {/* Show message if no images */}
              {!record.paymentImages?.length && !record.images?.length && (
                <Alert severity="info" sx={{ mt: 2 }}>
                  No images have been uploaded for this order yet.
                </Alert>
              )}
            </Box>
          )}

          {/* Show in-kind order notes if available */}
          {record.isInKind && (
            <Card sx={{ mt: 3 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                  Order Notes
                </Typography>
                <Divider sx={{ mb: 2 }} />

                <Grid container spacing={2}>
                  {record.dispatchNotes && (
                    <Grid item xs={12} md={6}>
                      <Labeled label="Dispatch Notes">
                        <Typography variant="body1">
                          {record.dispatchNotes}
                        </Typography>
                      </Labeled>
                    </Grid>
                  )}

                  {record.deliveryNotes && (
                    <Grid item xs={12} md={6}>
                      <Labeled label="Delivery Notes">
                        <Typography variant="body1">
                          {record.deliveryNotes}
                        </Typography>
                      </Labeled>
                    </Grid>
                  )}

                  {record.receiptNotes && (
                    <Grid item xs={12} md={6}>
                      <Labeled label="Receipt Notes">
                        <Typography variant="body1">
                          {record.receiptNotes}
                        </Typography>
                      </Labeled>
                    </Grid>
                  )}
                </Grid>
              </CardContent>
            </Card>
          )}
        </Tab>

        {/* Tab 3: Negotiation Details */}
        <Tab label="Negotiation" icon={<LocalOfferIcon />}>
          {record.negotiation && (
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                  Negotiation Details
                </Typography>
                <Divider sx={{ mb: 2 }} />

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={4}>
                    <Labeled label="Negotiation ID">
                      <Typography variant="body1">
                        #{record.negotiation.id}
                      </Typography>
                    </Labeled>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Labeled label="Type">
                      <Chip
                        label={record.negotiation.type}
                        color="primary"
                        variant="outlined"
                      />
                    </Labeled>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Labeled label="Trade Type">
                      <Chip
                        label={record.negotiation.tradeType}
                        color="secondary"
                        variant="outlined"
                      />
                    </Labeled>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Labeled label="Quantity">
                      <Typography variant="body1">
                        {record.negotiation.quantity}
                      </Typography>
                    </Labeled>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Labeled label="Status">
                      <Chip
                        label={record.negotiation.status}
                        color={
                          record.negotiation.status === 'Accepted' ? 'success' :
                            record.negotiation.status === 'Rejected' ? 'error' :
                              'warning'
                        }
                        variant="outlined"
                      />
                    </Labeled>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Labeled label="Created At">
                      <DateField
                        record={record.negotiation}
                        source="createdAt"
                        showTime
                      />
                    </Labeled>
                  </Grid>

                  <Grid item xs={12} sm={6} md={4}>
                    <Labeled label="Updated At">
                      <DateField
                        record={record.negotiation}
                        source="updatedAt"
                        showTime
                      />
                    </Labeled>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          )}
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

const OrderStatusToolbar = ({ onSave, ...props }) => (
  <Toolbar {...props}>
    <SaveButton label="Save" />
  </Toolbar>
);

export const OrderEdit = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  // const record = useRecordContext();
  const { id } = useParams();
  const [files, setFiles] = useState([]);
  const [category, setCategory] = useState('payment');
  const [update] = useUpdate();
  const fileInputRef = useRef();
  // const [selectedStatus, setSelectedStatus] = useState(record?.status || '');

  // Fetch the record manually
  const { data: record, isLoading, error } = useGetOne('orders', { id });
  // Initialize status without record
  const [selectedStatus, setSelectedStatus] = useState('');

  useEffect(() => {
    if (record) {
      setSelectedStatus(record.status || '');
    }
  }, [record]);

  if (isLoading) return <div>Loading order data...</div>;
  if (error) return <div>Error loading order: {error.message}</div>;
  if (!record) return <div>Order not found</div>;

  const handleFileChange = (fileList) => {
    // Filter valid files (images under 10MB)
    const validFiles = Array.from(fileList).filter(file => {
      const maxSizeMB = 10;
      const isValid = file.size <= maxSizeMB * 1024 * 1024 && file.type.startsWith('image/');
      if (!isValid) notify('Only image files under 10MB are allowed', { type: 'warning' });
      return isValid;
    }).slice(0, 5); // Limit to 5 files

    setFiles(validFiles);
  };

  const handleSave = async (data) => {
    try {
      console.log('Saving order with data:', data);
      // First upload images if any
      let imagePaths = [];
      if (files.length > 0) {
        const formData = new FormData();
        files.forEach(file => {
          formData.append('images', file);
        });
        const API_URL = process.env.REACT_APP_URL || 'http://localhost:3060';
        const token = JSON.parse(localStorage.getItem('token'));
        const response = await fetch(`${API_URL}/admin/files/upload-images/order/${record?.id}?category=${category}`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
          body: formData
        });

        if (!response.ok) throw new Error('Image upload failed');
        const result = await response.json();
        imagePaths = result.imagePaths;
      }

      // Then update status
      await update(
        'orders',
        {
          id: record?.id,
          data: {
            status: data.status,
            ...(imagePaths.length > 0 && {
              imagePaths,
              category
            })
          },
          previousData: record
        }
      );

      notify('Order updated successfully');
      redirect('show', 'orders', record?.id);
    } catch (error) {
      notify(`Error: ${error.message}`, { type: 'error' });
    }
  };

  return (
    <Edit {...props}>
      <SimpleForm onSubmit={handleSave} toolbar={<OrderStatusToolbar />} >
        <TextField source="id" label="Order ID" />
        <TextInput source="buyer.name" label="Buyer Name" disabled />
        <TextInput source="buyer.phonenumber" label="Buyer Phone" disabled />

        <SelectInput
          label="Status"
          source="status"
          choices={[
            { id: 'Pending', name: 'Pending' },
            { id: 'Processing', name: 'Processing' },
            { id: 'Shipped', name: 'Shipped' },
            { id: 'Delivered', name: 'Delivered' },
            { id: 'Paid', name: 'Paid' },
            { id: 'Cancelled', name: 'Cancelled' },
          ]}
          validate={[required()]}
          onChange={(e) => setSelectedStatus(e.target.value)}
        />

        {/* Show image upload when selected status is Paid or Delivered */}
        {['Delivered', 'Paid'].includes(selectedStatus) && (
          <>
            <SelectInput
              source="category"
              label="Image Type"
              choices={[
                { id: 'payment', name: 'Payment Proof' },
                { id: 'delivery', name: 'Delivery Proof' },
              ]}
              defaultValue="payment"
              onChange={(e) => setCategory(e.target.value)}
            />

            {/* <FileInput
              source="images"
              label="Upload Proof"
              accept="image/*"
              multiple
              maxSize={10 * 1024 * 1024}
              onChange={handleFileChange}
            >
              <FileField source="src" title="title" />
            </FileInput> */}
            <FileInput
              source="proofImages"
              label="Upload Proof"
              accept="image/*"
              multiple
              maxSize={10 * 1024 * 1024}
              onChange={(fileObjects) => {
                // React Admin provides an array of { src, title, rawFile }
                setFiles(fileObjects);
              }}
            >
              <FileField source="src" title="title" />
            </FileInput>

            {/* Display existing images if available */}
            {record?.paymentImages?.length > 0 && category === 'payment' && (
              <div>
                <label>Existing Payment Proofs</label>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  {record.paymentImages.map((img, i) => (
                    <ImageField key={i} source={img} />
                  ))}
                </div>
              </div>
            )}

            {record?.deliveryImages?.length > 0 && category === 'delivery' && (
              <div>
                <label>Existing Delivery Proofs</label>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  {record.deliveryImages.map((img, i) => (
                    <ImageField key={i} source={img} />
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </SimpleForm>
    </Edit>
  );
};